import apiClient from "@/libs/axios";

export const state = {
    data: [],

};

export const mutations = {
    setData: (state, data) => {
        state.data = data.data;

    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, is_active: data.is_active} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {
    async get({ commit }) {

        await apiClient
            .get(`api/v1/admin/notifications`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },

};

export const getters = {
    getData(state) {
        return state.data;
    },
};
